<template>
  <div>
    <h3 class="page__title">商户资产管理</h3>
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">开始日期</label>
        </div>
        <div class="weui-cell__bd" @click="pickerDate" >
          <a style="align-text:left ;color: #238E23;">{{dateStr}}</a>
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">截止日期</label>
        </div>
        <div class="weui-cell__bd" @click="pickerEndDate" >
          <a style="align-text:left ;color: #238E23;">{{dateEndStr}}</a>
        </div>
    </div>     
    <div class="weui-navbar">
        <div class="weui-navbar__item  weui-bar__item_on" id="nav_ld">
            链点
        </div>
        <div class="weui-navbar__item" id="nav_balance">
            储值卡
        </div>
    </div>
    <div class="weui-tab__panel" v-if="(resData != null)">
      <div class="table-responsive" >
        <table class="table table-striped " style="font-size: small;" >
          <thead>
            <tr>
              <th scope="col" >日期</th><!--
              <th scope="col" style="width:25%">单号</th>-->
              <th scope="col">备注</th>
            </tr>
            <tr v-show="(partnerid != 'M2022060601')">
              <td colspan="3" style="background-color:bisque;">
                <span v-show="mode == 'nav_ld'">您当前链点数量为：{{balanceDataLD.points}}【滴】
                  <a v-show="balanceDataLD.points > 0" class="underline_span" @click="toDir('ld_deposit')"> 申请兑付 </a> 
                  <a v-show="balanceDataLD.points < 100000000" class="underline_span" @click="toDir('ld_charge')"> 购买链点 </a>
                
                </span>
                <span v-show="mode == 'nav_balance'">您当前储值卡余额为:￥{{fenToCNY(balanceData.balance)}}</span>
                
              </td>
            </tr>
          </thead>
          <tbody v-show="mode == 'nav_balance'">
             <tr v-for="itm in flowData" :key="itm.createTime  + itm.id">
              <th scope="row">{{itm.createTime}}</th>
              <td><input  class="weui-input" autofocus type="text" placeholder="请输入地址" maxlength="64" :value="itm.vNo"/><br/>
                ￥{{fenToCNY(itm.balanceBefore)}}<span v-if="itm.direction==1">-</span><span v-else>+</span>￥{{fenToCNY(itm.amount)}}              
              =￥{{fenToCNY(itm.balanceAfter)}} <br/>
              {{itm.remark}}</td>
            </tr>
          </tbody>
          <tbody v-show="mode == 'nav_ld'" style="text-align:left">
             <tr v-for="itm in flowDataLD" :key="itm.createTime + itm.id">
              <th scope="row">{{itm.createTime}}</th>
              <td><input  class="weui-input" autofocus type="text" placeholder="请输入地址" maxlength="64" :value="itm.vNo"/><br/>
                {{(itm.pointsBefore)}}<span v-if="itm.direction==1">-</span><span v-else>+</span>{{(itm.changeNum)}}
          
              ={{(itm.pointsAfter)}}<br/>
              {{itm.remark}}</td>
            </tr>
          </tbody>
        </table>    
      </div>
    </div>
  </div>  
</template>

<style>
.underline_span{
  font:bold;
  text-underline-offset: 1px;
}


</style>
  
<script>
import 'bootstrap/dist/css/bootstrap.css'

import JQ from 'jquery'

import {getAssetBalance} from '../graphql/api'

function get2Str(str){
  return padding1(str,2);
}
function padding1(num, length) {
  for(var len = (num + "").length; len < length; len = num.length) {
   num = "0" + num;
  }
  return num;
 }


export default {


  data () {
    return {
      ing:true,
      openid:"",
      partnerid:"",
      date:this.$moment(new Date(),'YYYY-MM-01'),
      dateStr : this.$moment(new Date(),'YYYY-MM-01').format('YYYY-MM-01') ,
      dateEnd:new Date(),
      dateEndStr : new Date().Format("yyyy-MM-dd") ,
      balanceData:{balance:0},
      flowData : [],
      balanceDataLD:{points:0},
      flowDataLD : [],
      mode : "nav_ld",
      resData: null,
    }
  },
  watch :{
    ing(val,oval){
      console.log(val,oval);
    }
  },
  mounted() {
    this.openid = sessionStorage.getItem("openid")
    this.partnerid = sessionStorage.getItem("partnerid")

    let that = this;

    JQ('.weui-navbar__item').on('click', function () {
        JQ(this).addClass('weui-bar__item_on').siblings('.weui-bar__item_on').removeClass('weui-bar__item_on');
        console.log(JQ(this).attr("id"))
        that.mode = JQ(this).attr("id")
        console.log(that.mode)

        that.fillData();
        
    });


    this.getReport();
       
  },
  methods: {
    
    fenToCNY(fen){
      let prefix = "";
      let res= ""
      let intv = parseInt(fen)
      if(intv < 0) {
        intv = Math.abs(intv); 
        prefix = "-";
      }
      if(intv <= 9){
        res = "0.0"+ ( intv).toString();    
      }else if(intv <= 99){    
        res =  "0."+ ( intv).toString();   
      }else {
        res = intv.toString();
        res = res.substring(0,res.length-2) + "." + res.substring(res.length-2) 
      }
      return prefix+res;
   },
    pickerDate() {
      let that = this;
      this.$weui.datePicker({
            start: 2022,
            end: new Date().getFullYear(),
            onChange: function (result) {
                console.log(result);
                console.log(result[0].value +"-"+ result[1].value +"-"+ result[2].value );
            },
            onConfirm: function (result) {
                console.log(result);
                that.dateStr = result[0].value +"-"+ get2Str(result[1].value) +"-"+ get2Str(result[2].value);
                that.date = new Date(result[0].value,result[1].value,result[2].value)
                that.getReport(that.dateStr);
            },
            title: '请选择开始日期'
        });
    },
    pickerEndDate() {
      let that = this;
      this.$weui.datePicker({
            start: 2022,
            end: new Date().getFullYear(),
            onChange: function (result) {
                console.log(result);
                console.log(result[0].value +"-"+ result[1].value +"-"+ result[2].value );
            },
            onConfirm: function (result) {
                console.log(result);
                that.dateEnd = new Date(result[0].value,result[1].value,result[2].value)
                that.dateEndStr = result[0].value +"-"+ get2Str(result[1].value) +"-"+ get2Str(result[2].value);
                that.getReport(that.dateStr);
            },
            title: '请选择结束日期'
        });
    },
    showError(){
      var $warnToast = JQ('#warnToast');
      $warnToast.fadeIn(100);
      setTimeout(function () {
          $warnToast.fadeOut(100);
      }, 2000);
    },
    fillData(){
      
      if((this.resData == null)) {
        this.getReport();return;
      }

      if(this.resData.findPartnerBalanceInfo != null){
        this.balanceData = this.resData.findPartnerBalanceInfo.balance
        this.flowData = this.resData.findPartnerBalanceInfo.lstBalanceDetail
      }else{
        
        this.balanceData = {balance:0}
        this.flowData = []
      }
      if(this.resData.findPartnerPointsInfo != null){
        this.balanceDataLD = this.resData.findPartnerPointsInfo.points
        this.flowDataLD = this.resData.findPartnerPointsInfo.lstPointsRecord
      }else{
        
        this.balanceDataLD = {points:0}
        this.flowDataLD = []
      }
        
      let that = this;      
      that.ing=false;
    },
    toDir(str) {
      this.$router.push({
        name: str /*, 
        params: {
          dateStr: date,
          state: state,
          posid: 0
        }*/
      });
    },
    getReport(){
      
            
      console.log("getReport---------------------------------------------------------------------------------------")

      let that = this;
      this.ing=true;

      that.resData = null;

      let paras = {};

      paras.pid = this.partnerid;
      paras.bd = this.dateStr + " 00:00:00";
      paras.ed = this.dateEndStr + " 23:59:59";
      paras.ls = [1,2];
      paras.lt = null;//[1,2,3,4,5,6,7,8,9];
      paras.ld = [0,1];

      getAssetBalance(paras)
      // findAllWeChatAccDailyStatement(that.partnerid,{bd:"2022-12-01",ed:"2022-12-05 23:59:59",ls:[1,2],lt:[1,2,3,4]})
      .catch(err=>{
        console.log(err)
      })
      .then(res1=>{
       // alert(1)
        console.info('获取数据=》'+JSON.stringify(res1.data))
        //alert(JSON.stringify(res1.data))
        that.resData = res1.data;
        
        that.fillData();

      })
  
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/views/asset_mgr.vue